import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestmanageUserList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/subscriber-user`, {
      // params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/subscriber-user?${params}`, {
      // params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function requestCreateUser(data) {
  return fetch.post(`${BASE_URL}/api/app/subscriber-user`, data);
}
export function requestUpdateUser(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/subscriber-user/${data._id}`, body);
}
export function requestDeleteUser(data) {
  return fetch.delete(`${BASE_URL}/api/app/subscriber-user/${data}`);
}
export function requestUpdateUserDetails(data) {
  console.log(data);
  const body = { ...data };
  return fetch.post(
    `${BASE_URL}/api/app/subscriber-user/update-user/${data.id}`,
    body
  );
}
export function requestUserDataById(data) {
  return fetch.get(`${BASE_URL}/api/app/subscriber-user/getById/${data.id}`);
}

export function fetchUsersByRole(param) {
  return fetch.get(`${BASE_URL}/api/app/subscriber-user/get-users-by-role?role=${param}`)
}
